import { PRINT_URL } from "../../../../../constants/api";


const PatientProfileComponent = ({ item }) => {

    const handleImageError = (event) => {
        event.target.src = "/img/profile2.svg";
    }

    return (
        <>
            <div className="flex flex-col gap-4 border-b-2">
                <div className="w-full p-4">
                    <div className="flex flex-row gap-4">
                        <div className="w-42">
                            <img
                                className="rounded-full w-24 h-24"
                                alt=""
                                src={`${PRINT_URL}${item.profile_pic}`}
                                onError={handleImageError}
                            />
                        </div>
                        <div className="w-full flex flex-col gap-2 justify-center">
                            <label className="text-xs md:text-base ml-1 font-bold text-darkclr">{item.pat_name}</label>
                            <label className="text-xs md:text-sm ml-1 text-darkclr">{item.pat_acct_num}</label>
                            <label className="text-xs md:text-sm ml-1 text-darkclr">{item.pat_dob}</label>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default PatientProfileComponent;